import merge from 'lodash/merge'

import {
	RECORD_DSP2_TRANSACTION_BEGIN,
	RECORD_DSP2_TRANSACTION_SUCCESS,
	RECORD_DSP2_TRANSACTION_FAILURE
} from '../actions/recordDsp2Transaction'

const initialState = {
	loading: false,
	error: null,
	pspTransactionData: null
}

export default function recordDsp2TransactionReducers(state = initialState, action) {
	switch(action.type) {
		case RECORD_DSP2_TRANSACTION_BEGIN:
			return {
				...state,
				loading: true,
				error: null
			}

		case RECORD_DSP2_TRANSACTION_SUCCESS:
			return {
				...state,
				loading: false,
				pspTransactionData: merge({}, state.pspTransactionData, action.payload)
			}

		case RECORD_DSP2_TRANSACTION_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload.error,
				pspTransactionData: null,
				pspTransactionToken: null
			}

		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/recordDsp2TransactionReducers.js